export const menuHamberger = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const parentHeaderPanelButtons = document.querySelectorAll('.parent-header-panel-button');
        const subHeaderPanelButtons = document.querySelectorAll('.sub-header-panel-button');
        const subCollapsiblePanel = document.querySelectorAll('.sub-collapsible-panel');

        var oldAriaActivedescendant = '';
        parentHeaderPanelButtons.forEach(button => {
            if(window.innerWidth < 1000) {
                return false;
            }
            button.addEventListener('click', () => {
                const parentAriaControl = button.getAttribute('aria-controls');
                const parentAriaControlElement = document.querySelector(`#${parentAriaControl}`);

                if (parentAriaControlElement) {
                    setTimeout(function () {
                        const collapsiblePanel = parentAriaControlElement.closest('.header-sidebar__collapsible-panel');
                        const ariaActivedescendant = collapsiblePanel.getAttribute('aria-activedescendant');
                        if(oldAriaActivedescendant == ariaActivedescendant) {
                            if (collapsiblePanel.getAttribute('open') == null) {
                                collapsiblePanel.style.opacity = 1;
                                collapsiblePanel.style.display = 'block';
                                collapsiblePanel.style.transform = 'translateX(calc(var(--transform-logical-flip) * 100%)';
                                collapsiblePanel.setAttribute('open', true);
                            } else {
                                collapsiblePanel.removeAttribute('open');
                                collapsiblePanel.style.opacity = 0;
                            }
                        }else{
                            collapsiblePanel.style.opacity = 1;
                            collapsiblePanel.style.display = 'block';
                            collapsiblePanel.style.transform = 'translateX(calc(var(--transform-logical-flip) * 100%)';
                            collapsiblePanel.setAttribute('open', true);
                        }
                        oldAriaActivedescendant = ariaActivedescendant;
                    },100);
                }
                subCollapsiblePanel.forEach(panel => {
                    panel.classList.remove('menu-active');
                });
            });
        });


        var old_ariaControls = '';
        subHeaderPanelButtons.forEach(button => {
            button.addEventListener('click', () => {
                const ariaControls = button.getAttribute('aria-controls');
                const subContentMenu = button.parentElement.querySelector('.sub-header-panel').innerHTML;
                subCollapsiblePanel.forEach(panel => {
                    if (!ariaControls) {
                        panel.classList.remove('menu-active');
                        return;
                    }
                    if (document.querySelector(`.sub-collapsible-panel.${ariaControls}`)) {
                        if (panel.classList.contains('menu-active')) {
                            panel.classList.remove('menu-active');
                        } else {
                            panel.classList.add('menu-active');
                        }
                    } else {
                        if(old_ariaControls) {
                            panel.classList.remove(old_ariaControls);
                        }
                        panel.classList.add('menu-active');
                    }
                    panel.classList.add(ariaControls);
                    panel.querySelector('.header-sidebar__sub-panel').innerHTML = subContentMenu;
                    old_ariaControls = ariaControls;
                    return;
                });
            });
        });

        if(document.querySelector('[aria-controls="sidebar-menu"]')){
            document.querySelector('[aria-controls="sidebar-menu"]').addEventListener("click", function() {
                document.querySelectorAll(".sub-collapsible-panel").forEach(function(panel) {
                    panel.removeAttribute("style");
                });
            });
        }

        document.querySelector("body").addEventListener("click", function(e) {
            if (!e.target.closest(".header-sidebar__collapsible-panel") && !e.target.closest(".header-sidebar__main-panel")) {
                const subCollapsiblePanels = document.querySelectorAll(".menu-active");
                oldAriaActivedescendant = '';
                subCollapsiblePanels.forEach(function(panel) {
                    panel.style.display = "none";
                    panel.classList.remove("menu-active");
                });
            }
            if (e.target.matches('.sub-header-sidebar__back-button')) {
                const subCollapsiblePanel = document.querySelectorAll('.sub-collapsible-panel');
                subCollapsiblePanel.forEach(panel => {
                    panel.classList.remove('menu-active');
                });
            }
        });

        var searchClick = false;
        if(document.querySelector(".header__primary-nav  a")){
            document.querySelector(".header__primary-nav  a").addEventListener("click", function(){
                searchClick = true;
            });
        }

        window.onscroll = function(e) {
            var menuHeight = document.querySelector(".header-hide-down").offsetHeight;
            if(!searchClick){
                if(this.oldScroll > this.scrollY){
                    document.querySelector(".header-hide-down").style.transform = "translateY(0)";
                    document.querySelector(".header-hide-down").style.transition = 'transform 0.3s ease-in-out';
                    document.querySelector("header.shopify-section--header").classList.add("is-sticky");

                    document.querySelector("body").classList.add("sticky-menu");
                }else{
                    document.querySelector("header.shopify-section--header").classList.remove("is-sticky");
                    document.querySelector("body").classList.remove("sticky-menu");
                    if(this.scrollY > 50){
                        document.querySelector(".header-hide-down").style.transform = "translateY(-" + menuHeight + "px)";
                        document.querySelector(".header-hide-down").style.transition = 'transform 0.3s ease-in-out';
                    }
                }
                this.oldScroll = this.scrollY;
            }
            searchClick = false;
        }

    })
}
